import React from 'react'

const NoPadH3 = ({children}) => {
  return (
    <h3>{children}</h3>
  )
}

export default NoPadH3